<template>
  <div>
    <v-navigation-drawer
      height="100%"
      permanent
      :color="$vuetify.theme.primary || '#39424E'"
      dark
      class="drawer hidden-sm-and-down"
      width="327"
    >
      <div
        style="height: 100%; max-height: 950px"
        class="d-flex flex-column align-center"
      >
        <div class="pl-8 pr-4" style="width: 100%">
          <v-timeline dense>
            <v-timeline-item>
              <template v-slot:icon>
                <v-avatar
                  :color="step > 0 ? $store.state.colorDarkOrLight : 'white'"
                  size="57"
                  :style="
                    step == 0
                      ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                      : ''
                  "
                >
                  <v-icon :color="step > 0 ? 'white' : '#39424E'"
                    >mdi-account-outline</v-icon
                  >
                </v-avatar>
              </template>

              <div class="d-flex align-center">
                <strong class="step mr-4">1</strong>
                <div>
                  <span class="step-info">Informações pessoais</span>
                </div>
              </div>
            </v-timeline-item>

            <v-timeline-item>
              <template v-slot:icon>
                <v-avatar
                  :color="step > 1 ? $store.state.colorDarkOrLight : 'white'"
                  size="57"
                  :style="
                    step == 1
                      ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                      : ''
                  "
                >
                  <v-icon :color="step > 1 ? 'white' : '#39424E'"
                    >mdi-form-select</v-icon
                  >
                </v-avatar>
              </template>

              <div class="d-flex align-center">
                <strong class="step mr-4">2</strong>
                <div>
                  <span class="step-info">Questionário</span>
                </div>
              </div>
            </v-timeline-item>

            <v-timeline-item>
              <template v-slot:icon>
                <v-avatar
                  :color="step > 2 ? $store.state.colorDarkOrLight : 'white'"
                  size="57"
                  :style="
                    step == 2
                      ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                      : ''
                  "
                >
                  <v-icon :color="step > 2 ? 'white' : '#39424E'"
                    >mdi-card-text-outline</v-icon
                  >
                </v-avatar>
              </template>

              <div class="d-flex align-center">
                <strong class="step mr-4">3</strong>
                <div>
                  <span class="step-info">Cotação e Precificação</span>
                </div>
              </div>
            </v-timeline-item>

            <v-timeline-item>
              <template v-slot:icon>
                <v-avatar
                  :color="step > 3 ? $store.state.colorDarkOrLight : 'white'"
                  size="57"
                  :style="
                    step == 3
                      ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                      : ''
                  "
                >
                  <v-icon :color="step > 3 ? 'white' : '#39424E'"
                    >mdi-receipt-text-arrow-right-outline
                  </v-icon>
                </v-avatar>
              </template>

              <div class="d-flex align-center">
                <strong class="step mr-4">4</strong>
                <div>
                  <span class="step-info">Contratar</span>
                </div>
              </div>
            </v-timeline-item>

            <v-timeline-item style="padding-bottom: 0 !important">
              <template v-slot:icon>
                <v-avatar
                  :color="step > 4 ? $store.state.colorDarkOrLight : 'white'"
                  size="57"
                  :style="
                    step == 4
                      ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                      : ''
                  "
                >
                  <v-icon :color="step > 4 ? 'white' : '#39424E'"
                    >mdi-check</v-icon
                  >
                </v-avatar>
              </template>

              <div class="d-flex align-center">
                <strong class="step mr-4">5</strong>
                <div>
                  <span class="step-info">Finalização</span>
                </div>
              </div>
            </v-timeline-item>
          </v-timeline>
        </div>

        <div
          v-if="$vuetify.theme.primary"
          class="d-flex flex-column justify-space-around align-center mb-8"
        >
          <v-img
            class="mb-3"
            :src="$store.state.socio.logo"
            contain
            width="200"
          ></v-img>
        </div>
        <div
          v-else
          class="d-flex flex-column justify-space-around align-center mb-8 mt-8"
        >
          <v-img
            class="mb-3"
            src="../../../../assets/globus.svg"
            contain
            max-width="64"
          ></v-img>
          <v-img
            src="../../../../assets/name.svg"
            contain
            max-width="152"
          ></v-img>
        </div>
      </div>
    </v-navigation-drawer>

    <v-navigation-drawer
      height=""
      permanent
      color="#39424E"
      dark
      class="pa-4 mobile-drawer hidden-md-and-up"
      bottom
      width="100%"
      touchless
    >
      <div class="d-flex justify-center align-center">
        <div class="mobile-row">
          <div
            class="d-flex flex-column justify-center align-center text-center mobile-col"
          >
            <v-avatar
              :color="step > 0 ? $store.state.colorDarkOrLight : 'white'"
              size="55"
              :style="
                step == 0
                  ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                  : ''
              "
            >
              <v-icon :color="step > 0 ? 'white' : '#39424E'"
                >mdi-account-outline</v-icon
              >
            </v-avatar>

            <br />

            <span class="step-info"
              >Dados <br />
              básicos</span
            >
          </div>

          <div
            class="d-flex flex-column justify-center align-center text-center mobile-col"
          >
            <v-avatar
            :color="step > 1 ? $store.state.colorDarkOrLight : 'white'"
              size="55"
              :style="
                step == 1
                  ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                  : ''
              "
            >
              <v-icon :color="step > 1 ? 'white' : '#39424E'"
                >mdi-form-select</v-icon
              >
            </v-avatar>

            <br />

            <span class="step-info"> Questionário</span>
            <br />
          </div>

          <div
            class="d-flex flex-column justify-center align-center text-center mobile-col"
          >
            <v-avatar
            :color="step > 2 ? $store.state.colorDarkOrLight : 'white'"
              size="55"
              :style="
                step == 2
                  ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                  : ''
              "
            >
              <v-icon :color="step > 3 ? 'white' : '#39424E'"
                >mdi-card-text-outline</v-icon
              >
            </v-avatar>

            <br />

            <span class="step-info">Cotação e Precificação </span>
            <br />
          </div>

          <div
            class="d-flex flex-column justify-center align-center text-center mobile-col"
          >
            <v-avatar
            :color="step > 3 ? $store.state.colorDarkOrLight : 'white'"
              size="55"
              :style="
                step == 3
                  ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                  : ''
              "
            >
              <v-icon :color="step > 3 ? 'white' : '#39424E'"
                >mdi-receipt-text-arrow-right-outline
              </v-icon>
            </v-avatar>

            <br />

            <span class="step-info">Contratar </span>
            <br />
          </div>

          <div
            class="d-flex flex-column justify-center align-center text-center mobile-col"
          >
            <v-avatar
            :color="step > 4 ? $store.state.colorDarkOrLight : 'white'"
              size="55"
              :style="
                step == 4
                  ? `border: 5px solid ${$store.state.colorDarkOrLight} !important;`
                  : ''
              "
            >
              <v-icon :color="step > 4 ? 'white' : '#39424E'">mdi-check</v-icon>
            </v-avatar>

            <br />

            <span class="step-info">Finalização </span>
            <br />
          </div>
        </div>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<style scoped>
.drawer {
  border-radius: 25px 0px 0px 25px !important;
}

.mobile-drawer {
  display: flex;
  justify-content: space-around;
  border-radius: 0px 0px 25px 25px !important;
  width: 100%;
}

.mobile-row {
  max-width: 600px;
  padding-bottom: 10px;
  overflow-x: auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.mobile-row::-webkit-scrollbar {
  background-color: #ccc;
  width: 8px;
  height: 8px;
}

.mobile-row::-webkit-scrollbar-thumb {
  background-color: #f5f5f5;
  border-radius: 20px;
}

.mobile-col {
  min-width: 100px;
}

.v-timeline:before {
  width: 3px;
  background-color: #fff !important;
  height: 98%;
}

.step {
  font-weight: bold;
  font-size: 35px;
  line-height: 62px;
  text-align: right;
  letter-spacing: 0.15px;
  color: var(--custom-white-second-color);
}

.step-info {
  font-weight: normal;
  width: 100%;
  font-size: 15px;
  line-height: 16px;
  letter-spacing: 0.15px;
  color: var(--custom-white-second-color);
}

@media (max-width: 800px) {
  .step-info {
    font-size: 12px;
    line-height: unset;
  }

  .mobile-row {
    max-width: 320px;
    padding-bottom: 10px;
    overflow-x: auto;
  }
}
</style>

<script>
export default {
  props: {
    step: Number,
  },

  name: "Drawer",
};
</script>
